import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/target/component/action-button';
import ColumnTargetEcommerce from 'View/target/component/column-target-ecommerce';

import styles from './styles.module.css';

export const getTableList = ({ t }) => {
  const accessPermission = getMenuPermissions('achievement', 'target');

  const tableList = [
    {
      name: t('tableColumn.brand'),
      key: 'brandName',
      width: 150,
      component: ({ value }) => {
        return <TextRegular className={styles['column__text']}>{value}</TextRegular>;
      },
    },
    {
      name: t('tableColumn.columnAchievementTarget'),
      key: 'targetGmv',
      sortKey: 'targetGmv',
      width: 200,
      component: ({ value }) => {
        return <TextRegular className={styles['column__text']}>{value}</TextRegular>;
      },
    },
    {
      name: t('tableColumn.columnShopeeTarget'),
      key: 'shopeeTarget',
      width: 315,
      component: ({ value }) => {
        return <ColumnTargetEcommerce values={value} ecommerce={'Shopee'} />;
      },
    },
    {
      name: t('tableColumn.columnTiktokTarget'),
      key: 'tiktokTarget',
      width: 315,
      component: ({ value }) => {
        return <ColumnTargetEcommerce values={value} ecommerce={'Tiktok'} />;
      },
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: 'Action',
      key: 'id',
      width: 150,
      position: 'center',
      component: ({ values }) => <ActionButton values={values} />,
    });
  }

  return tableList;
};
